import ForgetPassword from "../Pages/Authentication/ForgetPassword";
import Login from "../Pages/Authentication/Login";
import SignInClassic from "../Pages/Authentication/SignInClassic";
import SignUp from "../Pages/Authentication/SignUp";
import { Route } from "./RouteList";

export const AuthRoutes = [
  { path: Route.Login, element: <Login /> },
  { path: Route.SignUp, element: <SignUp /> },
  { path: Route.SignInClassic, element: <SignInClassic /> },
  { path: Route.SignUpClassic, element: <SignInClassic /> },
  { path: Route.ForgetPassword, element: <ForgetPassword /> },
];
